$(document).ready(function()
{
    window.addEventListener("load", function()
    {
        if( window.cookieconsent ) 
        {
            window.cookieconsent.initialise({
                
                palette: {
                    popup: {
                        background: "#000",
                        text: "#fff",
                        link: '#fff'
                    },
                    button: {
                        background: "#ffffff",
                        text: '#000'
                    }
                },
                theme: "edgeless",
                content: {
                    message: "This website uses cookies to ensure you get the best experience.",
                    href: "/site-pages/privacy-policy/",
                    dismiss: 'Allow',
                },
                dismissOnScroll: false
            });
        }
    });
});